import { Box, MenuItem } from "@mui/material";
import { useFormikContext } from "formik";
import _ from "lodash";
import { ReactElement } from "react";

import { FormikSelect } from "~frontend/components/forms/FormSelect";
import FormikSwitchField from "~frontend/components/forms/FormikSwitchField";
import { useSubaccountAdminConfig } from "~frontend/providers/SubaccountProvider";

export default function LinkShortenerSettings({
  fieldPrefix,
}: {
  fieldPrefix?: string;
}): ReactElement | null {
  const subaccount = useSubaccountAdminConfig()!;
  const formik = useFormikContext();

  const values = formik.values as any;
  const overrideLinkShortenerSettings: boolean = _.get(
    values,
    `${fieldPrefix}.overrideLinkShortenerSettings`
  );

  if (
    subaccount.linkShortenerDomains.length === 0 &&
    !overrideLinkShortenerSettings
  ) {
    return null;
  }

  return (
    <Box sx={{ mb: 1 }}>
      <Box>
        <FormikSwitchField
          name={`${fieldPrefix}.overrideLinkShortenerSettings`}
          label={`Override default link settings (default setting: ${
            subaccount.defaultLinkShortenerDomainName
              ? `shorten with ${subaccount.defaultLinkShortenerDomainName}`
              : "link shortening disabled"
          })`}
          switchProps={{
            onChange: () => {
              // Mark script touched so it's validated -- if you change the link
              // shortener settings, it affects validation of the script
              formik
                .setFieldTouched(`${fieldPrefix}.script`, true)
                .catch(console.error);
            },
          }}
        />
      </Box>

      {overrideLinkShortenerSettings && (
        <FormikSelect
          fullWidth
          name={`${fieldPrefix}.linkShortenerDomainName`}
          label="Link Shortening Setting"
          onChange={() => {
            // Mark script touched so it's validated -- if you change the link
            // shortener settings, it affects validation of the script
            formik
              .setFieldTouched(`${fieldPrefix}.script`, true)
              .catch(console.error);
          }}
        >
          <MenuItem value="">
            Do not shorten links (disables click tracking)
          </MenuItem>
          {subaccount.linkShortenerDomains.map(({ domain }) => (
            <MenuItem key={domain} value={domain}>
              Shorten links with {domain}
            </MenuItem>
          ))}
        </FormikSelect>
      )}
    </Box>
  );
}
